export const EMAIL = 'ask@businesshalacha.com';
export const EMAIL_CONTACT = 'contact@businesshalacha.com';
export const EMAIL_HALACHA = 'halacha@businesshalacha.com';
export const PHONE = '718-233-3845';
